import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'
import { Font14, Font18, H4, H5 } from 'components/Typography'
import { BaseText } from 'components/Typography/Base'
import { CommonLinkButton } from 'components/Button'
import CommonButton from 'components/Button/CommonButton'

export const PurchaseSubscriptionMainBlock = styled.div`
  display: flex;
  flex-flow: wrap row;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 50px;
`

export const PurchaseSubscriptionBlock = styled(WhiteBlock)`
  display: flex;
  height: fit-content;
  gap: 16px;
  padding: 16px;
  flex: 3;
  flex-basis: 100%;
  width: 100%;

  @media ${theme.devices.tabletLandscape} {
    flex: 2;
    flex-basis: 0;
  }

  @media ${theme.devices.desktop} {
    flex: 3;
  }
`

export const PurchaseSubscriptionContentBlock = styled.div`
  display: flex;
  gap: 8px;
  flex-flow: wrap row;
`

export const PurchaseSubscriptionScrolledContentBlock = styled(
  PurchaseSubscriptionContentBlock
)`
  flex-flow: initial;
  overflow: auto;
`

export const PurchaseSubscriptionHeader = styled.div`
  display: flex;
  gap: 16px;
`

export const PurchaseSubscriptionHeaderTitle = styled(H5)`
  line-height: 24px;
  flex: 1;
`

export const PurchaseSubscriptionHeaderLinkButton = styled(CommonLinkButton)`
  text-decoration: underline;
  display: none;

  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const CheckoutBlockContainer = styled.div`
  display: flex;
  flex-flow: wrap row;
  align-items: center;
  width: 100%;

  @media ${theme.devices.tabletLandscape} {
    flex: 2;
  }

  @media ${theme.devices.tabletLandscape} {
    flex: 3;
  }
`
export const CheckoutBlockWrapper = styled(WhiteBlock)`
  width: 100%;
`

export const PurchaseSubscritpionTotalBlock = styled(WhiteBlock)`
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  padding: 40px 24px 24px;
  gap: 8px;
  flex: 1;
  height: fit-content;
`
export const PurchaseSubscritpionBlockItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${theme.colors.otterWarmBlack};
`

export const StyledPurchaseItemImg = styled.img`
  height: 50px;
  width: 50px;
`

export const PurchaseSubscritpionItemTitle = styled.span`
  font-weight: 900;
  color: ${theme.colors.otterWarmBlack};
`

export const PurchaseSubscritpionItemSubTitle = styled.span`
  ${Font14};
  color: ${theme.colors.otterWarmBlack};
`

export const PurchaseSubscritpionTotalTitle = styled.span`
  font-weight: 950;
  ${Font18};
  color: ${theme.colors.otterWarmBlack};
`

export const PurchaseSubscriptionBlockWrapper = styled.div<{
  disabled: boolean
}>`
  border-radius: 8px;
  padding: 16px;
  ${(p) =>
    p.disabled
      ? `background: ${theme.colors.lighterGrey};`
      : `border: 1px solid ${theme.colors.horizonOrange}; background-color: ${theme.colors.hover10};`}
  align-items: center;
  text-align: right;
  color: ${theme.colors.darkeyGrey};
  min-width: 250px;
  width: 100%;
  flex: 1;
  height: 180px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  > * {
    ${(p) => (p.disabled ? `color: ${theme.colors.lighterGrey};` : '')}
  }

  ${StyledPurchaseItemImg} {
    ${(p) =>
      p.disabled
        ? 'filter: invert(74%) sepia(0%) saturate(296%) hue-rotate(247deg) brightness(89%) contrast(94%);'
        : ''}
  }

  ${PurchaseSubscritpionItemTitle} {
    ${(p) => (p.disabled ? `color: ${theme.colors.darkeyGrey}` : '')}
  }
`

export const PurchaseSubscriptionFinalBlockWrapper = styled(
  PurchaseSubscriptionBlockWrapper
)`
  width: 274px;
  min-height: 132px;
  ${(p) =>
    p.disabled
      ? `background: ${theme.colors.lighterGrey};`
      : `border: none; background-color: ${theme.colors.lighterGrey};`}
  height: auto;
`

export const PurchaseSubscritpionItemSubtitle = styled.span`
  ${Font14};
  color: ${theme.colors.darkeyGrey};
  width: 100%;
  text-align: right;
  font-weight: bold;
`

export const PurchaseSubscritpionFinalItemSubtitle = styled(
  PurchaseSubscritpionItemSubtitle
)`
  line-height: 50px;
`

export const PurchaseSubscritpionItemSum = styled.span`
  color: ${theme.colors.horizonOrange};
  font-weight: bold;
`

export const PurchaseSubscritpionPointsSum = styled.span`
  ${Font14};
  color: ${theme.colors.otterWarmBlack};
`

export const PurchaseSubscritpionItemCount = styled.span`
  color: ${theme.colors.horizonOrange};
  font-weight: bold;
  margin-left: 8px;
`

export const PurchaseSubscritpionNetworkTotalLabel = styled.span`
  color: ${theme.colors.darkeyGrey};
  font-weight: bold;
`

export const BottomLine = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
  width: 100%;
`

export const BilledAnnualWrapper = styled.div`
  padding-top: 16px;
  flex: 0 0 100%;
  display: flex;
  justify-content: flex-end;
`
export const BilledAnnualLabel = styled.div`
  margin-bottom: 15px;
  background: ${theme.colors.hover10};
  border-radius: 8px;
  order: 0;
  padding: 8px;
  ${Font14};
  color: ${theme.colors.otterWarmBlack};
`

export const TaxTotalCostTitle = styled.span`
  font-weight: 325;
  font-size: 14px;
  line-height: 18px;
  color: ${theme.colors.moreGrey};
`

export const StyledAddCardWrapper = styled.div`
  width: 100%;
`

export const SectionLabel = styled(BaseText)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  min-height: 30px;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const StyledCardsBlock = styled.div`
  margin-bottom: ${theme.spacing.base};
`

export const StyledPaymentMethods = styled(WhiteBlock)`
  padding-bottom: ${theme.spacing.base};
`

export const StyledListCardWrapper = styled(WhiteBlock)`
  width: 100%;
  margin-bottom: 16px;
`

export const PurchaseStateWrapper = styled(WhiteBlock)`
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
  padding: 73px 48px 52px;

  @media ${theme.devices.tablet} {
    padding: 88px 0 67px;
  }
`

export const PurchaseStateIcon = styled(Icon)`
  margin-right: 8px;
`

export const PurchaseStateTitle = styled(H4)`
  margin-top: 20px;
`

export const PurchaseStateBody = styled.div`
  padding: 40px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 22px;
  text-align: center;
`

export const PurchaseStepBottomPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    justify-content: flex-end;
    gap: ${theme.spacing.base};
  }
`

export const PurchaseStepBottomPanelBtns = styled.div`
  display: flex;
  gap: ${theme.spacing.base};
`

export const PurchaseSubscriptionFooterBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.base};
`

export const SubscriptionInfoStyledManageButton = styled(CommonButton)`
  width: 127px;
  height: 40px;
`

export const SubscriptionInfoStyledCancelButton = styled(CommonButton)`
  width: 157px;
  height: 40px;
`
